import { Desc } from '@sm/intl';

import COPY from '~pricing/copy';

export type RouteObject = {
  [key: string]: Route;
};

export type Route = {
  path: string;
  title: Desc;
  packageType: string;
};

/**
 *
 * During runtime route, config title cannot be picked up when it is directly translated here,
 * so it is better to send the COPY object to the component to deal with it
 */

const ROUTE_CONFIG: RouteObject = {
  teams: {
    path: '/pricing/teams',
    title: COPY.TEAM_PLANS,
    packageType: 'teams',
  },
  individual: {
    path: '/pricing/individual',
    title: COPY.INDIVIDUAL_PLANS,
    packageType: 'individual',
  },
  enterprise: {
    path: '/pricing/enterprise',
    title: COPY.ENTERPRISE,
    packageType: 'enterprise',
  },
};

export default ROUTE_CONFIG;
